import Office from '../../../../layouts/office/Office/Office';
import Single from '../../../../layouts/single/Single/Single';
import css from './Layout.module.scss';
import classnames from 'classnames';
import ProtectedOffice from '../../../../common/decorators/ProtectedOffice';

const Wrapper = ({ children, translates, breadcrumbs, template, title, seoData, canonical }) =>
    template === 'templatecabinet' ? (
        <ProtectedOffice>
            <Office canonical={canonical} seoData={seoData} translates={translates} title={title} breadcrumbs={breadcrumbs}>
                <div className={classnames(css.containerPageCabinet)}>{children}</div>
            </Office>
        </ProtectedOffice>
    ) : (
        <div style={{ minHeight: '100%' }} className={classnames(css.contentPage, 'flexColumn', css.containerStore)}>
            <Single
                title={title}
                canonical={canonical}
                seoData={seoData}
                translates={translates}
                breadcrumbs={breadcrumbs}
                viewMoveUpBtn
            >
                <div className={classnames(css.containerPage)}>{children}</div>
            </Single>
        </div>
    );
export default Wrapper;
